<template>
    <div id="container">
        <video id="kollusPlayer" class="video-js vjs-default-skin kollus-default"></video>
    </div>
</template>

<script>
import loadJsCss from 'load-js-css';
import URLParser from 'url-parse';
import vgControllerLoader from '../vgControllerLoader';

export default {
    name: 'kollus-player-v3',
    props: {
        playerPolicy: {
            type: Object,
            required: true,
        },
        mediaInfoString: {
            type: String,
            required: true,
        },
        expireTime: {
            type: String,
        },
    },
    data() {
        return {
            playerConfig: this.playerPolicy.player_config.v3,
        }
    },
    beforeMount() {
        loadJsCss.list(this.playerConfig.resources);
    },
    mounted() {
        const urlParser = new URLParser(window.location);
        const timer = setInterval(() => {
            if (typeof window.Modules !== 'undefined') {
                const Player = Modules.get('com.kollus.kollusV3Player', 'Player');
                if (typeof Player !== 'undefined') {
                    clearInterval(timer);
                    let controllee;

                    if (!this.playerPolicy.is_live) {
                        vgControllerLoader.load('v3', 'kollusPlayer').then((v3controllee) => {
                            controllee = v3controllee;
                            try {
                                // postmessage를 통해 전달받은 플레이어 제어 명령 핸들러 등록
                                controllee.init();
                            } catch(e) {
                                // 발생 가능한 예외
                                // 1. PostMessage 사용 불가
                                console.error(e);
                            }
                        });
                    }

                    // console.log(this.playerPolicy.custom_scheme_uri);

                    Player.Options({
                        streamingInfo: {
                            mediaURL: this.playerPolicy.custom_scheme_uri,
                            isLive: this.playerPolicy.is_live,
                            posterURL: this.playerPolicy.poster_url,
                            expireTime: this.expireTime,
                        },
                        agentInfo: {
                            agentVersionCheckURL: this.playerConfig.version_api_url,
                            // agentExecuteURL: 'kollus://run', (20160923) kollus 프로토콜이 두번 호출되지 않는 오류 회피.
                            agentExecuteURL: this.playerConfig.agent_execute_url,
                            agentUpdateURL: this.playerConfig.agent_execute_url,
                            agentInstallURL: this.playerConfig.agent_install_url,
                        },
                        eventCallback: function (player) {
                            if (typeof controllee !== 'undefined') {
                                controllee.register_event_listeners(player);
                            }
                        },
                    });

                    switch (this.playerPolicy.scheme_command) {
                    case 'play_downloaded':
                        Player.StartPlay('download');
                        break;

                    case 'download':
                        Player.StartDownload({
                            folder: '',
                        });
                        break;

                    case 'play':
                        Player.StartPlay((this.playerPolicy.player_version === 'v3e') ? 'independant' : 'stream');
                        break;
                    }
                }
            }
        });
    },
};
</script>

<style scoped>
</style>
